import {
  DeleteIcon,
  GKButton,
  GKSearchSelect,
  GKTextField,
  Grid2,
  IconButton,
  Paper,
  PlusIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "components";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { handleReturnAutocompletePlaceholder } from "utils/StringFunctions";
import {
  billingFrequency,
  FeeMethod,
  FeeParameter,
  FeeType,
  // billingFrequency,
  // calculationFrequency,
  managementFeeCalculationMethod,
  SUBSCRIPTION_FREQUENCY,
} from "utils/constants";

const EditManagementFeePage = () => {
  const form: any = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "managementFee.managementFeeSlab",
  });

  form.watch(["managementFee.feeType", "managementFee.calculationBenchmark"]);

  const isFeeTypeFix = form.getValues("managementFee.feeType") !== "fixed";
  const isOpeningAUMBaseParameter = [
    "opening_aum_current_value",
    "opening_aum_portfolio_value",
  ].includes(form.getValues("managementFee.calculationBenchmark"));

  const isMonthEndPortfolioValue =
    form.getValues("managementFee.calculationBenchmark") ===
    "month_end_portfolio_value_average";

  return (
    <Grid2 container spacing={1}>
      <Grid2 size={12}>
        <Typography fontSize={18} fontWeight={500}>
          Management Fee
        </Typography>
      </Grid2>

      <Grid2 size={6}>
        <Controller
          name="managementFee.productName"
          control={form.control}
          render={({ field }) => (
            <GKTextField
              {...field}
              placeholder={handleReturnAutocompletePlaceholder({
                placeholder: "Select  Name",
                value: field.value,
              })}
              tooltipTitle="This name will appear on the invoices generated for your clients."
              inputLabel={"Product Name"}
            />
          )}
        />
      </Grid2>

      <Grid2 size={6}>
        <Controller
          name="managementFee.hsnCode"
          control={form.control}
          rules={{
            required: {
              value: true,
              message: "Please enter HSN code",
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKTextField
              {...field}
              requiredField
              placeholder={handleReturnAutocompletePlaceholder({
                placeholder: "Select  Code",
                value: field.value,
              })}
              inputLabel={"HSN Code"}
              tooltipTitle="This code will appear on invoices to classify your product for tax compliance."
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </Grid2>
      <Grid2 size={4}>
        <Controller
          name="managementFee.feeType"
          control={form.control}
          render={({ field }) => (
            <GKSearchSelect
              inputLabel="Fee Type"
              disableClearable={false}
              options={FeeType || []}
              onChange={(e, val) => {
                field.onChange(val?.value);
              }}
              value={
                FeeType.find((dataItem) => dataItem.value === field.value) || ""
              }
              getOptionLabel={(option) => option.name || option}
            />
          )}
        />
      </Grid2>
      {isFeeTypeFix && (
        <>
          <Grid2 size={4}>
            <Controller
              name="managementFee.feeMethod"
              control={form.control}
              render={({ field }) => (
                <GKSearchSelect
                  inputLabel="Fee Method"
                  disableClearable={false}
                  options={FeeMethod || []}
                  onChange={(e, val) => field.onChange(val?.value)}
                  value={
                    FeeMethod.find(
                      (dataItem) => dataItem.value === field.value,
                    ) || ""
                  }
                  getOptionLabel={(option) => option.name || option}
                />
              )}
            />
          </Grid2>
          <Grid2 size={4}>
            <Controller
              name="managementFee.calculationBenchmark"
              control={form.control}
              render={({ field }) => (
                <GKSearchSelect
                  inputLabel="Fee Parameter"
                  disableClearable={false}
                  options={FeeParameter}
                  onChange={(e, val) => field.onChange(val?.value)}
                  value={
                    FeeParameter.find(
                      (dataItem) => dataItem.value === field.value,
                    ) || ""
                  }
                  getOptionLabel={(option) => option.name || option}
                />
              )}
            />
          </Grid2>
        </>
      )}

      <Grid2 size={4}>
        <Controller
          name="managementFee.fee"
          control={form.control}
          render={({ field }) => (
            <GKTextField
              {...field}
              inputLabel={!isFeeTypeFix ? "Fee Amount" : "Fee %"}
              type="number"
            />
          )}
        />
      </Grid2>
      <Grid2 size={4}>
        <Controller
          name="managementFee.billFrequency"
          control={form.control}
          render={({ field }) => (
            <GKSearchSelect
              inputLabel="Billing Frequency"
              disableClearable={false}
              options={billingFrequency || []}
              onChange={(e, val) => field.onChange(val.value)}
              value={
                billingFrequency.find(
                  (dataItem) => dataItem.value === field.value,
                ) || ""
              }
              getOptionLabel={(option) => option.name || option}
            />
          )}
        />
      </Grid2>
      <Grid2 size={4}>
        <Controller
          name="managementFee.outOfPocketExpenses"
          control={form.control}
          render={({ field }) => (
            <GKTextField
              {...field}
              inputLabel="Out Of Pocket Expense"
              name="managementFee.outOfPocketExpenses"
              type="number"
            />
          )}
        />
      </Grid2>
      {/* <Grid2 size={4}>

          <Controller
            name="managementFee.minimumFee"
            control={form.control}
            render={({ field }) => (
              <GKTextField
                {...field}
                inputLabel="Minimum Fee"
                name="managementFee.minimumFee"
                type="number"
              />
            )}
          />

      </Grid2>
      <Grid2 size={4}>

          <Controller
            name="managementFee.maximumFee"
            control={form.control}
            render={({ field }) => (
              <GKTextField
                {...field}
                inputLabel="Maximum Fee"
                name="managementFee.maximumFee"
                type="number"
              />
            )}
          />

      </Grid2> */}
      {/* <Grid2 size={4}>

          <Controller
            name="managementFee.softHurdle"
            control={form.control}
            render={({ field }) => (
              <GKTextField
                {...field}
                inputLabel="Soft Hurdle"
                name="managementFee.softHurdle"
                type="number"
              />
            )}
          />

      </Grid2>
      <Grid2 size={4}>

          <Controller
            name="managementFee.hardHurdle"
            control={form.control}
            render={({ field }) => (
              <GKTextField
                {...field}
                inputLabel="Hard Hurdle"
                name="managementFee.hardHurdle"
                type="number"
              />
            )}
          />

      </Grid2> */}

      {isFeeTypeFix &&
        !isOpeningAUMBaseParameter &&
        !isMonthEndPortfolioValue && (
          <Grid2 size={4}>
            <Controller
              name="managementFee.calculationMethod"
              control={form.control}
              rules={{
                required: {
                  value: true,
                  message: "Please select a Calculation Method",
                },
              }}
              render={({ field }) => (
                <GKSearchSelect
                  {...field}
                  requiredField
                  inputLabel="Calculation Method"
                  disabled={
                    !form.getValues("managementFee.calculationBenchmark")
                  }
                  disableClearable={false}
                  options={
                    managementFeeCalculationMethod ||
                    // form.getValues("managementFee.calculationBenchmark") !== "aum"
                    //   ? managementFeeCalculationMethod.filter(
                    //       (dataItem) => dataItem.value === "trailing"
                    //     )
                    //   : managementFeeCalculationMethod
                    []
                  }
                  onChange={(e, val) => field.onChange(val?.value)}
                  value={
                    managementFeeCalculationMethod.find(
                      (dataItem) => dataItem.value === field.value,
                    ) || ""
                  }
                  getOptionLabel={(option) => option.name || option}
                  error={Boolean(
                    form?.formState?.errors?.managementFee?.calculationMethod,
                  )}
                  helperText={
                    form?.formState?.errors?.managementFee?.calculationMethod
                      ?.message
                  }
                />
              )}
            />
          </Grid2>
        )}

      {form.getValues("managementFee.highwatermark") && (
        <Grid2 size={4}>
          <Controller
            name="managementFee.highwatermarkAmount"
            control={form.control}
            render={({ field }) => (
              <GKTextField
                {...field}
                inputLabel="High Water Mark Amount"
                name="managementFee.highwatermarkAmount"
                type="number"
              />
            )}
          />
        </Grid2>
      )}

      {isOpeningAUMBaseParameter && !isMonthEndPortfolioValue && (
        <>
          <Grid2 size={4}>
            <Controller
              name="managementFee.minimumInvestment"
              control={form.control}
              render={({ field }) => (
                <GKTextField
                  {...field}
                  type="number"
                  inputLabel="Minimum investment"
                />
              )}
            />
          </Grid2>
          <Grid2 size={4}>
            <Controller
              name="managementFee.availableFrequency"
              control={form.control}
              render={({ field }) => (
                <GKSearchSelect
                  {...field}
                  disableClearable
                  inputLabel="Available Billing Frequency"
                  multiple
                  options={SUBSCRIPTION_FREQUENCY || []}
                  onChange={(event, val) => {
                    field.onChange(
                      val.map((option: { value: number }) => option.value),
                    );
                  }}
                  value={
                    SUBSCRIPTION_FREQUENCY?.filter(
                      (option: { value: string }) =>
                        field?.value?.includes(option?.value),
                    ) || []
                  }
                  getOptionLabel={(option) => option.name || option}
                />
              )}
            />
          </Grid2>
        </>
      )}

      {form.getValues("managementFee.feeMethod") === "slabs" && (
        <Grid2 size={12}>
          <TableContainer
            component={Paper}
            sx={{ marginTop: 2, minHeight: 100 }}
          >
            <Table
              sx={{ minWidth: 500 }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    style={{
                      padding: 12,
                    }}
                  >
                    <Typography
                      fontSize={16}
                      fontWeight={700}
                      color={"var(--primary-900)"}
                    >
                      Slabs
                    </Typography>
                  </TableCell>
                  <TableCell
                    colSpan={2}
                    align="right"
                    style={{
                      padding: 12,
                    }}
                  >
                    <Typography
                      fontSize={16}
                      fontWeight={700}
                      color={"var(--primary-900)"}
                    >
                      <GKButton
                        variant="outlined"
                        onClick={() => {
                          append({
                            lowerLimit: "",
                            upperLimit: "",
                            slabFee: "",
                          });
                        }}
                        startIcon={<PlusIcon />}
                      >
                        Add Slab
                      </GKButton>
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableHead>
                <TableRow>
                  <TableCell>From</TableCell>
                  <TableCell>To</TableCell>
                  <TableCell>Management Fee&nbsp;(%)</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {fields.map((row: any, index: number) => {
                  return (
                    <TableRow
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <Controller
                          name={`managementFee.managementFeeSlab[${index}].lowerLimit`}
                          control={form.control}
                          render={({ field }) => (
                            <GKTextField
                              {...field}
                              name={`managementFee.managementFeeSlab[${index}].lowerLimit`}
                              type="number"
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell>
                        <Controller
                          name={`managementFee.managementFeeSlab[${index}].upperLimit`}
                          control={form.control}
                          render={({ field }) => (
                            <GKTextField
                              {...field}
                              name={`managementFee.managementFeeSlab[${index}].upperLimit`}
                              type="number"
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell>
                        <Controller
                          name={`managementFee.managementFeeSlab[${index}].slabFee`}
                          control={form.control}
                          render={({ field }) => (
                            <GKTextField
                              {...field}
                              name={`managementFee.managementFeeSlab[${index}].slabFee`}
                              type="number"
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <IconButton
                          color="error"
                          className="outline"
                          disabled={fields.length === 1}
                          onClick={() => remove(index)}
                        >
                          <DeleteIcon width={16} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid2>
      )}
    </Grid2>
  );
};

export default EditManagementFeePage;
